import {RecordForm} from '../forms/RecordForm';
import {useMeter} from '../hooks/useMeter.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {Meter} from "../types.ts";

export const AddPage = () => {
    const { createRecord } = useMeter();

    return (
        <FormPageLayout
            title='Add Meter'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as Meter} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};